<template>
  <div>
    <goods-service-management />
  </div>
</template>

<script>
import GoodsServiceManagement from '@/components/sinvoice_viettel/GoodsServiceManagement.vue';

export default {
  name: 'GoodsServiceManagementView',
  components: { GoodsServiceManagement }
};
</script>

